export const blockIconsCommonactionsLockNew = (
	<span className='material-symbols-outlined'>lock</span>
);
